/**
 * 登录用户以 ‘p.’ 为前缀，  游客以 ‘g.’ 为前缀
 */
var USER_LOGIN_KEY = 'p.';
export function getUidFormUserId(userId) {
    if (!userId.includes('.')) {
        return userId;
    }
    return userId.split('.')[1];
}
export function isLoggingUser(userId) {
    if (!userId) {
        return false;
    }
    if (userId.startsWith(USER_LOGIN_KEY)) {
        return true;
    }
    return false;
}
